// extracted by mini-css-extract-plugin
module.exports = {"block":"_1410bfd27b--block--qaV7P"};